var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sss",staticStyle:{"height":"100%"}},[(_vm.isGuzi)?_c('iframe',{staticClass:"guziIframe",attrs:{"src":_vm.src,"title":""}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }